import * as types from "../types";

export const sessionCheckRequest = () => ({
  type: types.SESSION_CHECK_REQUEST,
});

export const sessionCheckSuccess = ({ sessionData }) => ({
  type: types.SESSION_CHECK_SUCCESS,
  payload: {
    sessionData,
  },
});

export const sessionCheckFailure = ({ error }) => ({
  type: types.SESSION_CHECK_FAILURE,
  payload: {
    error: error.message,
  },
});

export const sessionCheckReset = () => ({
  type: types.SESSION_CHECK_RESET,
});

// Explicitly marks the session as invalid (e.g. after logout), as opposed to
// sessionCheckReset which marks it as unknown/pending a fresh check.
export const sessionInvalidate = () => ({
  type: types.SESSION_INVALIDATE,
});
